import { DEBUG } from "../env";
import Stats from "stats.js";

export default function getStatsTracker(type = 0) {
  const stats = new Stats(type);
  const trackRender = () => stats.update();

  DEBUG && document.body.appendChild(stats.dom);

  return trackRender;
}
